import React from 'react'
import { Link } from 'react-router-dom'

import cx from 'classnames'

import { Box } from '@driftt/dds'

import ActivityActions, { ActionType } from 'components/ActivityActions'
import ActivityContentToolTip from 'components/ActivityContentTooltip'
import { AccountActivityUserAvatar } from 'components/Avatars'
import {
  ActivityEndUser,
  ActivityGroupByEndUser,
  CompanyData
} from 'modules/accountActivity/domain'
import { Insight } from 'modules/accountActivity/domain'
import { contactPath } from 'utils/paths'
import { segmentTrack, TrackType } from 'utils/tracking'

import utilityStyles from '../../../../../styles/utility.module.css'
import styles from './styles.module.css'

const getDisplayLocation = (endUserData: ActivityEndUser) => {
  const {
    locationCountryCode,
    locationCountry,
    locationCity,
    locationState,
    locationStateCode
  } = endUserData

  const items =
    locationCountryCode === 'US'
      ? [
          locationCity,
          locationCity ? locationStateCode || locationState : locationState || locationStateCode
        ]
      : [locationCity || locationState || locationStateCode, locationCountry]

  return items.filter(Boolean).join(', ')
}

interface ContactAndActionsProps {
  insight: Insight
  contact: ActivityGroupByEndUser
  isOnline: boolean
  companyData: CompanyData
}

const ContactAndActions = ({ insight, contact, isOnline, companyData }: ContactAndActionsProps) => {
  const displayName = contact.name || contact.email || 'Site visitor'
  const role = contact.role
  const endUserData = contact.endUserData || (contact.activityList[0] as any).endUserData
  const location = getDisplayLocation(endUserData)

  return (
    <Box className={styles.ContactAndActions}>
      <Box className={styles.contact}>
        <AccountActivityUserAvatar
          size="x-small"
          imageUrl={endUserData.avatarUrl}
          name={displayName}
          status={isOnline ? 'available' : 'away'}
        />
        <ActivityContentToolTip inCrm={!!insight.accountData} data={contact}>
          <Link
            onClick={() =>
              segmentTrack(TrackType.INSIGHT_FEED_VIEW_CONTACT, {
                insightId: insight.id,
                accountId: insight.accountId,
                contactId: contact.endUserId
              })
            }
            to={contactPath(contact.endUserId)}>
            <span className={cx(styles.displayName, utilityStyles.semiBoldWeight)}>
              {displayName}
            </span>
          </Link>
        </ActivityContentToolTip>
        {(role || location) && <span className={styles.roleOrLocation}>{role || location}</span>}
      </Box>

      <ActivityActions
        insight={insight}
        endUserData={endUserData}
        companyData={companyData}
        actionTypes={
          [
            isOnline && ActionType.CHAT,
            ActionType.LINKEDIN,
            ActionType.EMAIL,
            ActionType.OUTREACH,
            ActionType.SALESLOFT
          ].filter(Boolean) as ActionType[]
        }
      />
    </Box>
  )
}

export default ContactAndActions
